import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'

import { useAuthenticated } from '@jotta/auth-client/useAuthStatus'

import { PrivateLayout } from '../../components/Layout/PrivateLayout'
import { PublicLayout } from '../../components/Layout/PublicLayout'

export const PublicPhotoRouteContainer = observer(
  function PublicPhotoRouteContainer() {
    const authenticated = useAuthenticated() === 'TRUE'

    if (authenticated) {
      return (
        <PrivateLayout>
          <Outlet />
        </PrivateLayout>
      )
    }
    return (
      <PublicLayout section="sharedphotos">
        <Outlet />
      </PublicLayout>
    )
  },
)
